import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-success",
  "use": "icon-success-usage",
  "viewBox": "0 0 74 74",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 74 74\" id=\"icon-success\"><defs><style>#icon-success .a,#icon-success .c{fill:none;}#icon-success .a{stroke:currentColor;stroke-width:2px;}#icon-success .b{stroke:none;}</style></defs><g transform=\"translate(-163 -490.185)\"><g class=\"a\" transform=\"translate(163 490.185)\"><circle class=\"b\" cx=\"37\" cy=\"37\" r=\"37\" /><circle class=\"c\" cx=\"37\" cy=\"37\" r=\"36\" /></g><path class=\"a\" d=\"M-5164.145,18907.818l15.5,17.65,24.94-24.941\" transform=\"translate(5344.207 -18383.078)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/success.svg
// module id = cQmE
// module chunks = 76